/* services.js - cleaned version (alert removed)
   Upload to /assets/services.js
   This is the same script as before but the placeholder alert/preventDefault for the bottom CTA is removed.
*/
(function(){
  var ROOT_ID = 'services-module';
  var root = document.getElementById(ROOT_ID);
  if(!root) return; // nothing to do on other pages

  /* Title reveal */
  (function(){
    var el = root.querySelector('#heroTitle'); if(!el) return;
    var text = el.textContent.trim(); el.textContent = '';
    for(var i=0;i<text.length;i++){
      var ch = text.charAt(i);
      var s = document.createElement('span');
      s.textContent = ch;
      s.style.setProperty('--delay', (0.04*i + 0.12) + 's');
      s.style.opacity = '0';
      s.style.display = 'inline-block';
      s.style.transform = 'translateY(6px)';
      s.style.transition = 'transform .48s cubic-bezier(.2,.9,.3,1) var(--delay), opacity .48s var(--delay)';
      el.appendChild(s);
    }
    requestAnimationFrame(function(){
      var spans = el.querySelectorAll('span');
      spans.forEach(function(span){
        span.style.opacity = '1';
        span.style.transform = 'translateY(0)';
      });
    });
  })();

  /* Staggered entrance for cards */
  (function(){
    var cards = Array.from(root.querySelectorAll('.service-card'));
    if(!cards.length) return;
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries, obs){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            var idx = cards.indexOf(entry.target);
            setTimeout(function(){ entry.target.classList.add('visible'); }, idx * 80);
            obs.unobserve(entry.target);
          }
        });
      },{threshold:0.12});
      cards.forEach(function(c){ io.observe(c); });
    } else { cards.forEach(function(c){ c.classList.add('visible'); }); }
  })();

  /* Card tilt + image parallax (scoped) */
  (function(){
    var cards = root.querySelectorAll('.service-card');
    cards.forEach(function(card){
      var surface = card.querySelector('.service-surface');
      var img = surface ? surface.querySelector('.service-media img') : null;
      var particles = card.querySelectorAll('.particle');
      var cta = surface ? surface.querySelector('.card-cta') : null;
      if(!surface) return;

      card.addEventListener('pointermove', function(e){
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;

        var rx = (y * 10).toFixed(2);
        var ry = (x * -12).toFixed(2);
        var tz = 18;
        var tx = (x * 10).toFixed(2);
        var ty = (y * -8).toFixed(2);

        surface.style.transform = 'translateX(' + tx + 'px) translateY(' + ty + 'px) translateZ(' + tz + 'px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.06)';

        if(img){
          var imgTx = (x * -22).toFixed(2);
          var imgTy = (y * -12).toFixed(2);
          var imgScale = 1.14;
          img.style.transform = 'translate(' + imgTx + 'px,' + imgTy + 'px) scale(' + imgScale + ')';
        }

        if(cta){
          var ctaTx = (x * -6).toFixed(1);
          var ctaTy = (y * -4).toFixed(1);
          cta.style.transform = 'translate(' + ctaTx + 'px,' + ctaTy + 'px)';
        }

        particles && particles.forEach(function(p,i){
          var px = (x * 14) * (i+1) * 0.38;
          var py = (y * 10) * (i+1) * -0.38;
          p.style.transform = 'translate(' + px + 'px,' + py + 'px)';
          p.style.opacity = Math.min(0.06 + Math.abs(x*0.28) + Math.abs(y*0.28), 0.34);
        });
      });

      card.addEventListener('pointerleave', function(){
        surface.style.transform = '';
        if(img) img.style.transform = '';
        if(cta) cta.style.transform = '';
        particles && particles.forEach(function(p){
          p.style.transform = 'translateY(0)';
          p.style.opacity = 0.06;
        });
      });

      card.addEventListener('pointerdown', function(){ surface.style.transition = 'transform 120ms ease'; });
      card.addEventListener('pointerup', function(){ surface.style.transition = ''; });
    });
  })();

  /* Stars generation (scoped) */
  (function createStars(){
    var starfield = root.querySelector('#starfield'); if(!starfield) return;
    var N = 36;
    for(var i=0;i<N;i++){
      var s = document.createElement('div'); s.className = 'star';
      var left = Math.random()*100; var top = Math.random()*40; var size = (Math.random()*3) + 1;
      s.style.left = left + '%'; s.style.top = top + '%'; s.style.width = size + 'px'; s.style.height = size + 'px';
      var dur = (Math.random()*3) + 1.8; var delay = Math.random()*2;
      s.style.animationDuration = dur + 's'; s.style.animationDelay = delay + 's';
      starfield.appendChild(s);
    }
  })();

  /* Testimonials autoplay (scoped & accessible pause) */
  (function testimonialsAutoplay(){
    var row = root.querySelector('#testimonialRow'); if(!row) return;
    var speed = 0.36; var rafId=null; var paused=false;
    function step(){
      if(paused){ rafId = requestAnimationFrame(step); return; }
      row.scrollLeft += speed;
      if(row.scrollLeft + row.clientWidth >= row.scrollWidth - 1) row.scrollLeft = 0;
      rafId = requestAnimationFrame(step);
    }
    setTimeout(function(){ rafId = requestAnimationFrame(step); }, 600);
    row.addEventListener('pointerenter', function(){ paused = true; });
    row.addEventListener('pointerleave', function(){ paused = false; });
    row.addEventListener('focusin', function(){ paused = true; });
    row.addEventListener('focusout', function(){ paused = false; });
    if('IntersectionObserver' in window){ var io = new IntersectionObserver(function(entries){ entries.forEach(function(e){ paused = !e.isIntersecting; }); }, {threshold:0.1}); io.observe(row); }
  })();

  /* keyboard support for image-book CTAs (scoped) */
  (function(){ var ctas = root.querySelectorAll('.card-cta'); ctas.forEach(function(a){ a.setAttribute('tabindex','0'); a.addEventListener('keydown', function(ev){ if(ev.key==='Enter') a.click(); }); }); })();

  /* hide decorative elements from assistive tech */
  (function(){ root.querySelectorAll('.animated-gradient, .particles, #starfield').forEach(function(el){ el.setAttribute('aria-hidden','true'); }); })();

})();


/* ======= Disable heavy pointer interactions on touch / small screens ======= */
(function disablePointerEffectsOnTouch(){
  // small utility: returns true for touch devices or narrow screens
  var isTouchOrSmall = ('ontouchstart' in window) || window.matchMedia('(max-width:760px)').matches || window.matchMedia('(pointer:coarse)').matches;
  if(!isTouchOrSmall) return;

  // remove or short-circuit pointermove listeners that create tilt/parallax:
  var cards = root.querySelectorAll('.service-card');
  cards.forEach(function(card){
    // clone node without event listeners (simple way) — keep attributes & children
    var clone = card.cloneNode(true);
    card.parentNode.replaceChild(clone, card);
    // add a simple focus/press handler for basic UX (no tilt)
    clone.addEventListener('touchstart', function(){ clone.classList.add('visible'); }, {passive:true});
    clone.addEventListener('touchend', function(){ /* nothing heavy */ }, {passive:true});
  });

  // ensure sheen removed on touch for buttons
  var sheens = root.querySelectorAll('.btn-primary .sheen');
  sheens.forEach(function(s){ s.style.display = 'none'; });
})();